<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapse1"
                    aria-expanded="false" aria-controls="collapse1">
                Niet aftrekbare boetes
            </button>
        </h2>
        <div id="collapse1" class="accordion-collapse collapse show" aria-labelledby="heading1"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Niet aftrekbaar zijn:
                <br/>
                <ul>
                    <li>Geldboeten opgelegd door een Nederlandse strafrechter.</li>
                    <li>Geldboeten betaald aan de Staat ter voorkoming van strafvervolging.</li>
                    <li>Bestuurlijke boeten.</li>
                    <li>Tuchtrechtelijke boeten.</li>
                    <li>Buitenlandse geldboeten.</li>
                    <li>Boeten en verhogingen opgelegd op grond van de Algemene wet inzake rijksbelastingen, de Douanewet,
                        deCoördinatiewet
                        Sociale Verzekering en de Wet administratiefrechtelijke handhaving verkeersvoorschriften.
                    </li>
                    <li>Boeten opgelegd door de Autoriteit Consument & Markt.</li>
                </ul>
            </div>
        </div>
    </div>
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                    data-bs-target="#collapse2" aria-expanded="false" aria-controls="collapse2">
                Beperkt aftrekbare kosten
            </button>
        </h2>
        <div id="collapse2" class="accordion-collapse collapse" aria-labelledby="heading2"
             data-bs-parent="#accordionExample">
            <div class="accordion-body">
                Er geldt een aftrekbeperking voor zogenaamde gemengde kosten. Dit zijn uitgaven die naast het zakelijke doel ook het
                persoonlijke leven van derden dienen. Vul hier alleen het niet-aftrekbare deel van deze kosten in.
                <br/>
                <br/>
                <div *ngIf="this.year === 2024">
                    <b>Drempel beperkt aftrekbare kosten 2024</b>
                    <br>
                    Bepaalde zakelijke kosten zijn beperkt aftrekbaar. Het gaat om bijvoorbeeld representatiekosten en bepaalde
                    relatiegeschenken. Deze kosten kun je pas aftrekken als ze boven de drempel uitkomen. Er geldt in 2024 een drempel
                    van € 5.600.
                    <br><br/>
                    In plaats van deze drempel mogen ondernemers voor de vennootschapsbelasting 73,5% van deze kosten aftrekken in de
                    aangifte. Voor ondernemers voor de inkomstenbelasting geldt het percentage van 80%. Dat percentage geldt ook
                    voor degenen die inkomsten uit overig werk hebben.
                </div>
                <div *ngIf="this.year === 2023" >
                    <b>Drempel beperkt aftrekbare kosten 2023</b>
                    <br>
                    Bepaalde zakelijke kosten zijn beperkt aftrekbaar. Het gaat om bijvoorbeeld representatiekosten en bepaalde
                    relatiegeschenken. Deze kosten kun je pas aftrekken als ze boven de drempel uitkomen. Er geldt in 2023 een drempel
                    van € 5.100.
                    <br><br/>
                    In plaats van deze drempel mogen ondernemers voor de vennootschapsbelasting 73,5% van deze kosten aftrekken in de
                    aangifte. Voor ondernemers voor de inkomstenbelasting geldt het percentage van 80%. Dat percentage geldt ook
                    voor degenen die inkomsten uit overig werk hebben.
                </div>
            </div>
        </div>
    </div>
</div>

